exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh3[data-v-68881638] {\n    font-size: 24px;\n}\n.labeled-text[data-v-68881638] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-flex: 1;\n        -ms-flex: 1 0 auto;\n            flex: 1 0 auto;\n}\n.labeled-text span[data-v-68881638] {\n    padding-left: 5px;\n    line-height: 24px;\n}\n", ""]);

// exports
